module.exports = __webpack_public_path__ + "static/how-it-works-step-3-5a50b30543fd8d6908ce369f30095085.png";